const PRICE_PATTERN = /\b(\d{1,3}(?:,\d{3})*)\.(\d{2})\s*(?:TRY|TL|₺)\b/g;
const LEGACY_ROUTES = {
  '/tasarla': '/pages/kendin-tasarla',
  '/organizer': '/collections/saat-ve-mucevher-kutulari',
};

if (LEGACY_ROUTES[window.location.pathname]) {
  window.location.replace(LEGACY_ROUTES[window.location.pathname]);
}

function localizePriceText(root = document) {
  const selectors = [
    '.price',
    '.sweb-price',
    '.sweb-home-hero__price',
    '.sweb-card__price',
    '.sweb-product__price',
    '.sweb-product__compare',
    '.compare-at-price',
    '[data-testid*="price"]',
    '.cart-item__price',
    '.cart-summary__total',
  ];
  root.querySelectorAll?.(selectors.join(',')).forEach((element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue.replace(PRICE_PATTERN, (_, whole, decimal) => `${whole.replaceAll(',', '.')},${decimal} TL`);
    }
  });
}

localizePriceText();
new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) localizePriceText(node);
  }));
}).observe(document.body, { childList: true, subtree: true });
